import { ActionReducer, createReducer, on } from '@ngrx/store';
import { CategoryRestrictionProfilePresetConfigurationApiActions } from './category-restriction-profile-preset-configuration.actions';
import {
  adapter,
  CategoryRestrictionProfilePresetConfigurationState,
  initialState,
  selectId,
} from './category-restriction-profile-preset-configuration.state';

export const categoryRestrictionProfilePresetConfigurationReducer: ActionReducer<CategoryRestrictionProfilePresetConfigurationState> =
  createReducer(
    initialState,
    on(
      CategoryRestrictionProfilePresetConfigurationApiActions.restrictionProfileConfigurationLoaded,
      (state, { configurations }) => {
        return adapter.setMany(configurations, state);
      }
    ),
    on(
      CategoryRestrictionProfilePresetConfigurationApiActions.restrictionProfileConfigurationSet,
      (state, { category, configurations }) => {
        const intermediateState = adapter.removeMany((x) => selectId(x).includes(category.categoryId), state);
        return adapter.setMany(configurations, intermediateState);
      }
    )
  );

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectRestrictionProfilePresetConfigurationIds = selectIds;

export const selectRestrictionProfilePresetConfigurationEntities = selectEntities;

export const selectAllRestrictionProfilePresetConfigurations = selectAll;
